import { Component, OnInit, inject } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { registerLocaleData } from '@angular/common'
import localeFr from '@angular/common/locales/fr'
import { NgbModalConfig, NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap'
import { OAuthService } from 'angular-oauth2-oidc'
import { authConfig } from './configuration/auth.config'
import { JwksValidationHandler } from 'angular-oauth2-oidc-jwks'

registerLocaleData(localeFr)

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet],
    standalone: true,
})
export class AppComponent implements OnInit {
    private oauthService = inject(OAuthService)

    constructor() {
        const configModal = inject(NgbModalConfig)
        const configTooltip = inject(NgbTooltipConfig)
        const oauthService = this.oauthService

        configModal.centered = true
        configModal.backdrop = 'static'

        configTooltip.container = 'body'
        configTooltip.openDelay = 600

        oauthService.configure(authConfig)
        oauthService.tokenValidationHandler = new JwksValidationHandler()
        oauthService.setStorage(localStorage)
    }

    ngOnInit(): void {
        this.removeStartupLoader()
    }

    removeStartupLoader() {
        const startupLoader: HTMLElement | null = document.getElementById('startup-loader')
        if (startupLoader) {
            startupLoader.remove()
        }
    }
}
